module.exports = __webpack_public_path__ + "media/images/briefly_logo24_transparent_white-b3ea19d529a77983439bd80eaf964ece.svg";